import React, { useContext } from 'react';
import LazyImage from '../../../../common/suspense/LazyImage';

import { ReactComponent as OfferIcon } from '../../../../../resources/img/icons/local_offer.svg';
import { ReactComponent as BorderAllIcon } from '../../../../../resources/img/icons/border_all.svg';
import { ReactComponent as ReplayIcon } from '../../../../../resources/img/icons/replay.svg';

import { ReactComponent as EyeIcon } from '../../../../../resources/img/icons/eye-grey.svg';
import { ReactComponent as PhoneIcon } from '../../../../../resources/img/icons/phone-grey.svg';
import { ReactComponent as FavoriteIcon } from '../../../../../resources/img/icons/favorite-grey2.svg';
import { ReactComponent as CartIcon } from '../../../../../resources/img/icons/cart-grey.svg';
import { ReactComponent as RatingIcon } from '../../../../../resources/img/icons/rating-grey.svg';
import { Tooltip } from './Tooltip';
import { Functions } from 'libs';
import { useAnalyticsContext } from '../AnalyticsProvider';
import { formatStatValue } from '../helpers';
import { AppDataContext } from 'contexts/appData';

export const Info = () => {
  const { total, sellStatistics, ranking, product } = useAnalyticsContext();
  const { langs } = useContext(AppDataContext);

  const isOnlineProduct = product?.sell_online === 1 || product?.shop_type_id === 1;
  const isOnlineShop = product?.shop_type_id === 1

  return (
    <div className="bg-white mb-16px p-16px p-md-20px border-radius-md-12" style={{ border: '1px solid #EEE' }}>
      <div className="d-flex justify-content-center justify-content-md-between align-items-center gap-36px flex-wrap flex-md-nowrap">
        <div className="d-flex gap-12px align-items-center mr-auto">
          <div
            style={{
              borderRadius: 8,
              overflow: 'hidden',
              minWidth: '126px',
              maxWidth: '164px',
              width: '100%',
              maxHeight: '124px',
              minHeight: '96px',
              display: 'flex',
            }}
          >
            <LazyImage src={product?.photos?.length > 0 ? product?.photos[0]?.thumbs : ''} alt={product?.title} className="object-fit-cover w-100 h-100" />
          </div>
          <div>
            <div className="font-size-12" style={{ color: '#6F7383' }}>
              ID: {product?.product_id}
            </div>
            <div className="font-medium font-size-14">{product?.title}</div>
            <div className="d-flex align-items-center gap-4px">
              <div className="font-medium text-nowrap font-size-16" style={{ color: '#161616' }}>
                {Functions.formatMoney(product?.price)} ₾
              </div>
              {product?.old_price > 0 && product?.old_price !== product?.price && (
                <div className="text-nowrap font-size-14" style={{ color: '#8996AE', textDecorationLine: 'line-through' }}>
                  {Functions.formatMoney(product?.old_price)} ₾
                </div>
              )}
              {product?.discount > 0 && (
                <div className="text-nowrap font-size-14" style={{ color: '#028D71' }}>
                  -{product?.discount}%
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="d-flex" style={{ height: 'fit-content' }}>
          <div className="d-flex flex-column align-items-center gap-6px cursor-pointer analytics-stats-item-0">
            <RatingIcon />
            <div className="font-medium" style={{ fontSize: 16 }}>
              #
              {ranking || 0}
            </div>

            <Tooltip anchor=".analytics-stats-item-0" text={langs?.NM_RankingTooltip} />
          </div>

          <div style={{ width: '1px', background: '#DADBDD', margin: '0px 20px' }}></div>

          <div className="d-flex align-items-center gap-32px">
            <div className="d-flex flex-column align-items-center gap-4px cursor-pointer analytics-stats-item analytics-stats-item-1">
              <EyeIcon />
              <div className="font-medium" style={{ fontSize: 14 }}>
                {formatStatValue(total?.views || 0)}
              </div>

              <Tooltip anchor=".analytics-stats-item-1" text={langs?.NM_AllViews} />
            </div>

            <div className="d-flex flex-column align-items-center gap-4px cursor-pointer analytics-stats-item analytics-stats-item-2">
              <PhoneIcon />
              <div className="font-medium" style={{ fontSize: 14 }}>
                {formatStatValue(total?.phone_views || 0)}
              </div>

              <Tooltip anchor=".analytics-stats-item-2" text={langs?.NM_AllCalls} />
            </div>

            <div className="d-flex flex-column align-items-center gap-4px cursor-pointer analytics-stats-item analytics-stats-item-3">
              <FavoriteIcon />
              <div className="font-medium" style={{ fontSize: 14 }}>
                {formatStatValue(total?.favorites || 0)}
              </div>

              <Tooltip anchor=".analytics-stats-item-3" text={langs?.NM_AllFavorites} />
            </div>

            {isOnlineShop && (
              <div className="d-flex flex-column align-items-center gap-4px cursor-pointer analytics-stats-item analytics-stats-item-4">
                <CartIcon />
                <div className="font-medium" style={{ fontSize: 14 }}>
                  {formatStatValue(total?.add_to_cart || 0)}
                </div>
              </div>
            )}

            <Tooltip anchor=".analytics-stats-item-4" text={langs?.NM_AllInCart} />
          </div>
        </div>
      </div>


      {isOnlineProduct && (
        <>
          <hr style={{ margin: '20px 0' }} />
          <div className="d-flex gap-16px flex-wrap flex-sm-nowrap px-20px px-sm-0" style={{ justifyContent: 'space-around' }}>
            <div className="d-flex gap-32px gap-sm-16px" style={{ justifyContent: 'space-around', width: '100%' }}>
              <div className="d-flex justify-content-sm-center align-items-center gap-10px flex-sm-column flex-md-row w-1/2 w-sm-auto">
                <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36, borderRadius: 8, background: '#EEE' }}>
                  <OfferIcon />
                </div>
                <div className="d-flex align-items-center gap-4px">
                  <div className="font-medium font-size-14 font-size-md-16" style={{ color: '#222' }}>
                    {sellStatistics?.sold_products_count || 0}
                  </div>
                  <div className="font-medium font-size-10 font-size-md-12" style={{ color: '#7A7A7A' }}>
                    {langs?.NM_Sold}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-sm-center align-items-center gap-10px flex-sm-column flex-md-row w-1/2 w-sm-auto">
                <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36, borderRadius: 8, background: '#EEE' }}>
                  <ReplayIcon />
                </div>
                <div className="d-flex align-items-center gap-4px">
                  <div className="font-medium font-size-14 font-size-md-16" style={{ color: '#222' }}>
                    {sellStatistics?.returned_products_count || 0}
                  </div>
                  <div className="font-medium font-size-10 font-size-md-12" style={{ color: '#7A7A7A' }}>
                    {langs?.NM_Returned}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex gap-32px gap-sm-16px" style={{ justifyContent: 'space-around', width: '100%' }}>
              <div className="d-flex justify-content-sm-center align-items-center gap-10px flex-sm-column flex-md-row w-1/2 w-sm-auto">
                <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36, borderRadius: 8, background: '#EEE' }}>
                  <BorderAllIcon />
                </div>
                <div className="d-flex align-items-center gap-4px">
                  <div className="font-medium font-size-14 font-size-md-16" style={{ color: '#222' }}>
                    {sellStatistics?.cancelled_products_count || 0}
                  </div>
                  <div className="font-medium font-size-10 font-size-md-12" style={{ color: '#7A7A7A' }}>
                    {langs?.NM_Cancelled}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-sm-center align-items-center gap-10px flex-sm-column flex-md-row w-1/2 w-sm-auto">
                <div className="d-flex justify-content-center align-items-center" style={{ width: 36, height: 36, borderRadius: 8, background: '#EEE' }}>
                  <BorderAllIcon />
                </div>
                <div className="d-flex align-items-center gap-4px">
                  <div className="font-medium font-size-14 font-size-md-16" style={{ color: '#222' }}>
                    {sellStatistics?.current_stock || 0}
                  </div>
                  <div className="font-medium font-size-10 font-size-md-12" style={{ color: '#7A7A7A' }}>
                    {langs?.NM_InStock}
                  </div>
                </div>
              </div>
            </div>
          </div>{' '}
        </>
      )}
    </div>
  );
};
